var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBytesList, FctString, FctValue } from '../../../../Fct/generics';
import { exchangeRouterContracts, TOKENS } from '../constants';
import { GMXHelper } from '../helpers/GMXHelper';
var gmxHelper = new GMXHelper({ chainId: '42161' });
export var ClosePositionMulticall = createPlugin({
    protocol: 'GMX',
    type: 'ACTION',
    method: 'multicall',
    name: 'closePositionMulticall',
    supportedContracts: exchangeRouterContracts,
    getParams: function (_a) {
        var _b;
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                value: new FctValue({ readonly: true }),
                receiveToken: new FctAddress({
                    destination: 'erc20',
                    mode: 'INPUT',
                    options: (_b = TOKENS[Number(chainId)]) === null || _b === void 0 ? void 0 : _b.filter(function (token) { return !token.isSynthetic; }),
                }),
                position: new FctString({ mode: 'INPUT' }),
                methodParams: {
                    data: new FctBytesList({ readonly: true }),
                },
            },
            output: {
                results: new FctBytesList({}),
            },
        });
    },
    setValuesAsync: function (_a) {
        var chainId = _a.chainId, account = _a.account, input = _a.input, provider = _a.provider;
        return __awaiter(void 0, void 0, void 0, function () {
            var tokensData, marketsInfo, positonsInfo;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        gmxHelper.setLibrary({ chainId: chainId, provider: provider, account: account });
                        return [4 /*yield*/, gmxHelper.getTokensData()];
                    case 1:
                        tokensData = _b.sent();
                        return [4 /*yield*/, gmxHelper.getMarketsInfo()];
                    case 2:
                        marketsInfo = _b.sent();
                        if (tokensData.tokensData && tokensData.pricesUpdatedAt) {
                            gmxHelper.tokensData = tokensData;
                        }
                        gmxHelper.marketsInfo = marketsInfo === null || marketsInfo === void 0 ? void 0 : marketsInfo.marketsInfoData;
                        return [4 /*yield*/, gmxHelper.getPositionsInfo({
                                marketsInfoData: marketsInfo === null || marketsInfo === void 0 ? void 0 : marketsInfo.marketsInfoData,
                                tokensData: tokensData.tokensData,
                                pricesUpdatedAt: tokensData.pricesUpdatedAt,
                            })];
                    case 3:
                        positonsInfo = _b.sent();
                        if (!(positonsInfo === null || positonsInfo === void 0 ? void 0 : positonsInfo.positionsInfoData))
                            return [2 /*return*/];
                        if (input)
                            input.position.options = Object.keys(positonsInfo.positionsInfoData).map(function (key) {
                                var _a = positonsInfo.positionsInfoData[key], marketInfo = _a.marketInfo, indexToken = _a.indexToken, entryPrice = _a.entryPrice, collateralToken = _a.collateralToken, liquidationPrice = _a.liquidationPrice, leverage = _a.leverage, closingFeeUsd = _a.closingFeeUsd;
                                var shortToken = marketInfo.shortToken, longToken = marketInfo.longToken;
                                return {
                                    value: key,
                                    marketAddress: marketInfo.marketTokenAddress,
                                    logoURI: indexToken.logoURI,
                                    name: "".concat(indexToken.symbol, " / USD"),
                                    indexToken: indexToken.symbol,
                                    longToken: longToken.symbol,
                                    shortToken: shortToken.symbol,
                                    collateralToken: collateralToken.symbol,
                                    entryPrice: entryPrice === null || entryPrice === void 0 ? void 0 : entryPrice.toString(),
                                    liquidationPrice: liquidationPrice === null || liquidationPrice === void 0 ? void 0 : liquidationPrice.toString(),
                                    leverage: leverage === null || leverage === void 0 ? void 0 : leverage.toString(),
                                    closingFeeUsd: closingFeeUsd === null || closingFeeUsd === void 0 ? void 0 : closingFeeUsd.toString(),
                                };
                            });
                        return [2 /*return*/];
                }
            });
        });
    },
    calculateValuesOnUserInput: function (_a) {
        var chainId = _a.chainId, input = _a.input, account = _a.account, provider = _a.provider;
        if (gmxHelper.chainId !== Number(chainId) || gmxHelper.account !== account) {
            gmxHelper.setLibrary({ chainId: chainId, provider: provider, account: account });
        }
        var helper = gmxHelper;
        var getClosePositionParams = function () { return __awaiter(void 0, void 0, void 0, function () {
            var closingPositionKey, receiveTokenAddress, closeAmountsParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        closingPositionKey = input.position.value;
                        receiveTokenAddress = input.receiveToken.value;
                        if (!closingPositionKey)
                            return [2 /*return*/];
                        if (!receiveTokenAddress)
                            return [2 /*return*/];
                        if (typeof closingPositionKey !== 'string') {
                            console.error("position should be string value");
                            return [2 /*return*/];
                        }
                        if (typeof receiveTokenAddress !== 'string') {
                            console.error("receiveToken should be string value");
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, helper.getClosePositionParams({
                                closingPositionKey: closingPositionKey,
                                receiveTokenAddress: receiveTokenAddress,
                                // marketsInfoData: marketsInfo?.marketsInfoData,
                                // tokensData: tokenData.tokensData,
                                // pricesUpdatedAt: tokenData.pricesUpdatedAt,
                            })];
                    case 1:
                        closeAmountsParams = _a.sent();
                        if (!closeAmountsParams) {
                            return [2 /*return*/, {
                                    params: {
                                        value: undefined,
                                        methodParams: {
                                            data: undefined,
                                        },
                                    },
                                    error: 'get close amount params error',
                                }];
                        }
                        return [2 /*return*/, {
                                params: {
                                    value: closeAmountsParams.totalWntAmount,
                                    methodParams: {
                                        data: closeAmountsParams.encodedPayload,
                                    },
                                },
                                error: undefined,
                            }];
                }
            });
        }); };
        return { get: getClosePositionParams, depParamKeys: ['receiveToken', 'position'] };
    },
});
